import React, { Suspense } from 'react';
import { BaseModal } from './Modals.js';
import Model3DViewer from './Model3DViewer.js';
import Spinner from './Spinner.js';

export default function Modal3DViewer({ modelName, modelUrl, onClose }) {
  return (
    <BaseModal
      title={`Visor 3D - ${modelName}`}
      size="xl"
      onClose={onClose}
    >
      <BaseModal.Body>
        <Suspense
          fallback={
            <div className="text-center py-5">
              <Spinner />
              <p className="mt-3 text-muted">Cargando modelo 3D...</p>
            </div>
          }
        >
          <Model3DViewer modelUrl={modelUrl} height="70vh" />
        </Suspense>
      </BaseModal.Body>

      <BaseModal.Footer>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onClose}
        >
          Cerrar
        </button>
      </BaseModal.Footer>
    </BaseModal>
  );
}
